import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";

// Public class booking endpoints. The booking link uid is the tenant scope,
// exactly as the other widget endpoints scope their requests.
const API_URL = config.API_URL;

const classSessions = ({ uid, days }) => {
  const data = { uid };
  if (days) {
    data.days = days;
  }
  return axios.get(API_URL + "widget/class/sessions", { params: data });
};

const classCheckoutPayload = (values) => {
  const data = {
    uid: values && values.uid ? values.uid : "",
    session_id: values && values.session_id ? values.session_id : "",
    seats: values && values.seats ? values.seats : 1,
    idempotency_key: values && values.idempotency_key ? values.idempotency_key : "",
    accepted_cancellation_policy: values?.accepted_cancellation_policy === true,
    client: {
      client_id: values && values.client_id ? values.client_id : null,
      name: values && values.name ? values.name : "",
      first_name: values?.first_name || "",
      last_name: values?.last_name || "",
      email: values && values.email ? values.email : "",
      phone: values && values.phone ? values.phone : "",
    },
  };
  if (values?.payment_intent_id) data.payment_intent_id = values.payment_intent_id;
  return data;
};
const bookClassSession = (values) => axios.post(API_URL + "widget/class/book", classCheckoutPayload(values));
const prepareClassDeposit = (values) => axios.post(API_URL + "widget/class/payment-intent", classCheckoutPayload(values));

const classConfirmation = ({ uid, token }) =>
  axios.get(API_URL + `widget/class/confirmation/${encodeURIComponent(token)}`, {
    params: { uid },
  });

const cancelClassBooking = (values) => {
  const data = {
    uid: values && values.uid ? values.uid : "",
    booking_id: values && values.booking_id ? values.booking_id : "",
  };
  return axios.post(API_URL + "widget/class/bookings/cancel", data);
};

// Salon-side (authenticated) class endpoints. These drive the admin class
// panel and the in-salon booking drawer, so they carry the bearer token the
// other Flask REST calls use.
const salonClassSessions = () =>
  axios.get(API_URL + "class/sessions", { headers: authHeader() });

const createSalonClassSession = (values) => {
  const data = {
    name: values.name || "",
    start_at: values.start_at || "",
    duration_minutes: Number(values.duration_minutes) || 0,
    capacity: Number(values.capacity) || 0,
    timezone: values.timezone || "UTC",
    price: values.price === undefined || values.price === "" ? "0.00" : String(values.price),
    deposit_amount:
      values.deposit_amount === undefined || values.deposit_amount === ""
        ? "0.00"
        : String(values.deposit_amount),
    cancellation_window_hours: Number(values.cancellation_window_hours) || 0,
    staff_id: values.staff_id || null,
    resource_item_id: values.resource_item_id || null,
    service_id: values.service_id || null,
    is_online_bookable: values.is_online_bookable !== false,
  };
  return axios.post(API_URL + "class/sessions", data, { headers: authHeader() });
};

const updateSalonClassSession = (values) => {
  const data = {};
  if (values.name !== undefined) data.name = values.name;
  if (values.capacity !== undefined) data.capacity = Number(values.capacity);
  if (values.duration_minutes !== undefined) data.duration_minutes = Number(values.duration_minutes);
  if (values.start_at !== undefined) data.start_at = values.start_at;
  for (const field of ['staff_id','resource_item_id','service_id']) {
    if (values[field] !== undefined) data[field] = values[field] ? Number(values[field]) : null;
  }
  for (const field of ['price','deposit_amount']) {
    if (values[field] !== undefined) data[field] = String(values[field] || '0.00');
  }
  if (values.timezone !== undefined) data.timezone = values.timezone;
  if (values.cancellation_window_hours !== undefined) data.cancellation_window_hours = Number(values.cancellation_window_hours);
  if (values.is_online_bookable !== undefined) data.is_online_bookable = values.is_online_bookable;
  if (values.is_active !== undefined) data.is_active = values.is_active;
  return axios.patch(API_URL + `class/sessions/${values.id}`, data, { headers: authHeader() });
};

const salonClassBookings = (values = {}) => {
  const params = {};
  if (values.from) params.from = values.from;
  if (values.to) params.to = values.to;
  if (values.session_id) params.session_id = values.session_id;
  if (values.client_id) params.client_id = values.client_id;
  if (values.include_cancelled) params.include_cancelled = 1;
  return axios.get(API_URL + "class/bookings", { params, headers: authHeader() });
};

const bookClientIntoClass = (values) => {
  const data = {
    seats: values.seats ? Number(values.seats) : 1,
    idempotency_key: values.idempotency_key || "",
    client: {
      client_id: values.client_id || null,
      name: values.name || "",
      email: values.email || "",
      phone: values.phone || "",
    },
  };
  if (values.collect_deposit === true) {
    data.collect_deposit = true;
    data.deposit_payment_method = values.deposit_payment_method;
  }
  return axios.post(API_URL + `class/sessions/${values.session_id}/book`, data, {
    headers: authHeader(),
  });
};

const cancelSalonClassBooking = (bookingId) =>
  axios.post(API_URL + `class/bookings/${bookingId}/cancel`, {}, { headers: authHeader() });

export default {
  classSessions,
  bookClassSession,
  prepareClassDeposit,
  classConfirmation,
  cancelClassBooking,
  salonClassSessions,
  createSalonClassSession,
  updateSalonClassSession,
  salonClassBookings,
  bookClientIntoClass,
  cancelSalonClassBooking,
};
